<template>
  <!-- Erklär-Einblendung beim Überfahren mit der Maus bzw. bei Tastaturfokus
       (Kundenfeedback 02.10.2026, erster Teil, II und V): Titel plus ein Satz,
       was das Symbol tut. Der Anker ist ein eigenes Element, damit die
       Einblendung auch über deaktivierten Schaltflächen erscheint. -->
  <span class="chat-tip" :class="{ 'chat-tip--block': block }">
    <slot />
    <v-tooltip
      activator="parent"
      :close-delay="0"
      content-class="chat-tip__pop"
      :location="location"
      :max-width="TIP_MAX_WIDTH"
      :open-delay="TIP_OPEN_DELAY_MS"
      open-on-focus
    >
      <strong class="chat-tip__title">{{ title }}</strong>
      <span v-if="text" class="chat-tip__text">{{ text }}</span>
    </v-tooltip>
  </span>
</template>

<script setup lang="ts">
  /** Kurz genug, um sofort zu wirken; lang genug, um beim Vorbeifahren nicht zu flackern. */
  const TIP_OPEN_DELAY_MS = 120
  const TIP_MAX_WIDTH = 280

  withDefaults(defineProps<{
    /** Name der Funktion (fett). */
    title: string
    /** Ein Satz, was passiert. */
    text?: string
    location?: 'top' | 'bottom' | 'start' | 'end'
    /** Anker füllt die Breite des Elternelements (z. B. Segment-Schalter). */
    block?: boolean
  }>(), { text: '', location: 'bottom', block: false })
</script>

<style scoped>
.chat-tip { display: inline-flex; }
.chat-tip--block { display: flex; flex: 1; min-width: 0; }
.chat-tip--block > :slotted(*) { flex: 1; }
/* Deaktivierte Schaltflächen schlucken Mausereignisse – der Anker übernimmt. */
.chat-tip > :slotted(:disabled) { pointer-events: none; }
</style>

<style>
/* Die Einblendung wird an das Seitenende teleportiert, daher nicht scoped. */
.chat-tip__pop.v-overlay__content {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 9px 12px;
  border-radius: 10px;
  background: #1f2733;
  color: #fff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.28);
  font-size: 0.78rem;
  line-height: 1.4;
}
.chat-tip__title { font-weight: 700; letter-spacing: 0.005em; }
.chat-tip__text { color: rgba(255, 255, 255, 0.82); }
</style>
